import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { StyledCheckboxItemDiv, StyledCheckboxItemsContainer } from '../../organisms/SearchResults/index.styles';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledAmenitiesFilterDiv = styled.div`
  ${rtl`
  padding-top: ${toRem(24)};
  
  .tooltip-amenity {
    align-content: end;
    padding-left: ${toRem(1)};
    margin-bottom: ${toRem(-2)};
    position: relative;
    .tooltip-information {
      position: absolute;
      bottom: 0;
      .tooltip-icon {
        position: relative;
        padding: 0;
        &:after {
          position: relative;
          top: ${toRem(2)};
          font-size: ${toRem(16)};
        }
        &:hover {
          background-color: transparent;
        }
        &:focus {
          border: none;
        }
        .tooltip-dialog {
          position: absolute;
          transform: translateX(-46%) translateY(-74%);
          z-index: 1;
        }
      }
    }
  }

  ${StyledCheckboxItemDiv} {
    input[type='checkbox'] + label {
      &.checkbox-label {
        padding-left: ${toRem(30)};
        padding-right: 0;
        width: fit-content;
      }
    }
  }

  @media only ${theme.mediaQuery.allMobiles} {
    padding-top: 0;
    padding-bottom: 0;
    ${StyledCheckboxItemDiv} {
      width: 100%;
    }
    ${StyledCheckboxItemsContainer} {
      margin-bottom: ${toRem(16)};
    }
  }

  .show-more-less-option {
    display: flex;
    align-items: flex-start;
    margin-top: ${toRem(8)};

    .icon-arrow-up,
    .icon-arrow-down {
      margin-left: ${toRem(6)};
    }
    &:hover {
      cursor: pointer;
    }
  }
  `}
`;

export const StyledAmenitiesFilterHeaderContainerDiv = styled.div`
  ${rtl`
  margin-bottom: ${toRem(16)};
  @media only ${theme.mediaQuery.allMobiles} {
      margin-top: ${toRem(16)};
      margin-bottom: 0;
  }
  `}
`;

export const StyledAmenitiesModalFilterDiv = styled.div`
  ${rtl`
  .pop-up-footer {
    padding: ${toRem(12)} ${toRem(16)};
    @media ${baseVariables.mediaQuery.md} {
      padding: ${toRem(20)} ${toRem(32)};
    }
  }
  .filter-option-button.active {
    background-color: ${theme.color['close-silver']};
  }
  .filter-option-button {
    font-weight: ${theme.fonts['fontWeightRegular']};
  }
  .filter-option-button:focus {
    outline: 0px solid -webkit-focus-ring-color;
  }
  `}
`;

export const StyledAmenitiesTooltipDiv = styled.div<{
  labelWidth?: number;
}>`
  ${rtl`
    .tooltip-information{
      left: ${({ labelWidth }: { labelWidth: number }) => `${labelWidth}px`};
    }
  `}
`;

export const StyledAmenitiesCheckBoxItemDiv = styled.div<{
  zIndexValue?: number;
}>`
  ${rtl`
      position: relative;
      z-index: ${({ zIndexValue }: { zIndexValue: number }) => `${zIndexValue}`};
  `}
`;
